import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Books from "./pages/Books";
import InteractiveBooks from "./pages/InteractiveBooks";
import Courses from "./pages/Courses";
import Institutional from "./pages/Institutional";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Disclaimer from "./pages/Disclaimer";
import CorporateDiscounts from "./pages/CorporateDiscounts";
import CIRECorporateAccess from "./pages/CIRECorporateAccess";
import RSECorporateAccess from "./pages/RSECorporateAccess";
import ISECorporateAccess from "./pages/ISECorporateAccess";
import DerivativesCorporateAccess from "./pages/DerivativesCorporateAccess";
import CIREExam from "./pages/CIREExam";
import RSEExam from "./pages/RSEExam";
import ISEExam from "./pages/ISEExam";
import DerivativesExam from "./pages/DerivativesExam";
import ExamComparison from "./pages/ExamComparison";
import CIREStudyGuide from "./pages/CIREStudyGuide";
import RSEStudyGuide from "./pages/RSEStudyGuide";
import ISEStudyGuide from "./pages/ISEStudyGuide";
import DerivativesStudyGuide from "./pages/DerivativesStudyGuide";
import DiagnosticTool from "./pages/DiagnosticTool";
import DerivativesStrategyLab from "./pages/DerivativesStrategyLab";
import DerivativesStrategiesBlog from "./pages/DerivativesStrategiesBlog";
import InvestmentAcademy from "./pages/InvestmentAcademy";
import CIREInteractiveBook from "./pages/CIREInteractiveBook";
import CIREElement from "./pages/CIREElement";
import CIREMockExam from "./pages/CIREMockExam";
import CIREMockExamPackSalesPage from "./pages/CIREMockExamPackSalesPage";
import MockExam1 from "./pages/cire-mock-exams/MockExam1";
import MockExam2 from "./pages/cire-mock-exams/MockExam2";
import MockExam3 from "./pages/cire-mock-exams/MockExam3";
import MockExam4 from "./pages/cire-mock-exams/MockExam4";
import MockExam5 from "./pages/cire-mock-exams/MockExam5";
import CIREElementQuestionBankSalesPage from "./pages/CIREElementQuestionBankSalesPage";
import CIREElement1Practice from "./pages/cire-element-practice/Element1";
import CIREElement2Practice from "./pages/cire-element-practice/Element2";
import CIREElement3Practice from "./pages/cire-element-practice/Element3";
import CIREElement4Practice from "./pages/cire-element-practice/Element4";
import CIREElement5Practice from "./pages/cire-element-practice/Element5";
import CIREElement6Practice from "./pages/cire-element-practice/Element6";
import CIREElement7Practice from "./pages/cire-element-practice/Element7";
import CIREElement8Practice from "./pages/cire-element-practice/Element8";
import CIREElement9Practice from "./pages/cire-element-practice/Element9";
import RSEMockExamPackSalesPage from "./pages/RSEMockExamPackSalesPage";
import DerivativesMockExamPackSalesPage from "./pages/DerivativesMockExamPackSalesPage";
import DerivativesMockExam1 from "./pages/derivatives-mock-exams/MockExam1";
import DerivativesMockExam2 from "./pages/derivatives-mock-exams/MockExam2";
import DerivativesMockExam3 from "./pages/derivatives-mock-exams/MockExam3";
import DerivativesMockExam4 from "./pages/derivatives-mock-exams/MockExam4";
import DerivativesMockExam5 from "./pages/derivatives-mock-exams/MockExam5";
import DerivativesElementQuestionBankSalesPage from "./pages/DerivativesElementQuestionBankSalesPage";
import DerivativesElement1 from "./pages/derivatives-element-wise/Element1";
import DerivativesElement2 from "./pages/derivatives-element-wise/Element2";
import DerivativesElement3 from "./pages/derivatives-element-wise/Element3";
import DerivativesElement4 from "./pages/derivatives-element-wise/Element4";
import DerivativesElement5 from "./pages/derivatives-element-wise/Element5";
import DerivativesElement6 from "./pages/derivatives-element-wise/Element6";
import DerivativesElement7 from "./pages/derivatives-element-wise/Element7";
import DerivativesElement8 from "./pages/derivatives-element-wise/Element8";
import RSEMockExam1 from "./pages/rse-mock-exams/MockExam1";
import RSEMockExam2 from "./pages/rse-mock-exams/MockExam2";
import RSEMockExam3 from "./pages/rse-mock-exams/MockExam3";
import RSEMockExam4 from "./pages/rse-mock-exams/MockExam4";
import RSEMockExam5 from "./pages/rse-mock-exams/MockExam5";
import RSEElementQuestionBankSalesPage from "./pages/RSEElementQuestionBankSalesPage";
import RSEElement1Practice from "./pages/rse-element-practice/Element1";
import RSEElement2Practice from "./pages/rse-element-practice/Element2";
import RSEElement3Practice from "./pages/rse-element-practice/Element3";
import RSEElement4Practice from "./pages/rse-element-practice/Element4";
import RSEElement5Practice from "./pages/rse-element-practice/Element5";
import RSEElement6Practice from "./pages/rse-element-practice/Element6";
import RSEElement7Practice from "./pages/rse-element-practice/Element7";
import RSEElement8Practice from "./pages/rse-element-practice/Element8";
import RSEElement9Practice from "./pages/rse-element-practice/Element9";
import CIREInteractiveBlog from "./pages/CIREInteractiveBlog";
import RSEInteractiveGuideBlog from "./pages/RSEInteractiveGuideBlog";
import DerivativesInteractiveGuideBlog from "./pages/DerivativesInteractiveGuideBlog";
import ISEInteractiveGuideBlog from "./pages/ISEInteractiveGuideBlog";
import AllCIROExamsGuideBlog from "./pages/AllCIROExamsGuideBlog";
import RSEInteractiveBook from "./pages/RSEInteractiveBook";
import RSEElement from "./pages/RSEElement";
import RSEMockExam from "./pages/RSEMockExam";
import DerivativesInteractiveBook from "./pages/DerivativesInteractiveBook";
import DerivativesElement from "./pages/DerivativesElement";
import DerivativesMockExam from "./pages/DerivativesMockExam";
import ISEInteractiveBook from "./pages/ISEInteractiveBook";
import ISEElement from "./pages/ISEElement";
import ISEMockExam from "./pages/ISEMockExam";
import ISEMockExamPackSalesPage from "./pages/ISEMockExamPackSalesPage";
import ISEMockExam1 from "./pages/ise-mock-exams/MockExam1";
import ISEMockExam2 from "./pages/ise-mock-exams/MockExam2";
import ISEMockExam3 from "./pages/ise-mock-exams/MockExam3";
import ISEMockExam4 from "./pages/ise-mock-exams/MockExam4";
import ISEMockExam5 from "./pages/ise-mock-exams/MockExam5";
import ISEElementQuestionBankSalesPage from "./pages/ISEElementQuestionBankSalesPage";
import ISEElement1Practice from "./pages/ise-element-practice/Element1";
import ISEElement2Practice from "./pages/ise-element-practice/Element2";
import ISEElement3Practice from "./pages/ise-element-practice/Element3";
import ISEElement4Practice from "./pages/ise-element-practice/Element4";
import ISEElement5Practice from "./pages/ise-element-practice/Element5";
import ISEElement6Practice from "./pages/ise-element-practice/Element6";
import ISEElement7Practice from "./pages/ise-element-practice/Element7";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import TradersExam from "./pages/TradersExam";
import TradersExamStudyGuide from "./pages/TradersExamStudyGuide";
import EducationalInstitutes from "./pages/EducationalInstitutes";
import NorquestCollege from "./pages/NorquestCollege";

// Layout wrapper to conditionally show header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const noLayoutPaths = ['/payment/success', '/payment/cancel'];
  const hideLayout = noLayoutPaths.some(path => location.pathname.startsWith(path));
  
  // Also hide for element pages (full screen interactive content)
  const isElementPage = location.pathname.match(/^\/books\/(cire|rse|derivatives|ise)-interactive\/element-\d+$/);
  const isMockExamPage = location.pathname.match(/^\/(cire|rse|derivatives|ise)-mock-exam$/) || 
                         location.pathname.match(/^\/books\/cire-mock-exams\/mock-exam-\d+$/) ||
                         location.pathname.match(/^\/books\/rse-mock-exams\/mock-exam-\d+$/) ||
                         location.pathname.match(/^\/books\/derivatives-mock-exams\/mock-exam-\d+$/) ||
                         location.pathname.match(/^\/ise-mock-exam\/\d+$/) ||
                         location.pathname.match(/^\/books\/cire-element-practice\/element-\d+$/) ||
                         location.pathname.match(/^\/books\/rse-element-practice\/element-\d+$/) ||
                         location.pathname.match(/^\/books\/derivatives-element-practice\/element-\d+$/) ||
                         location.pathname.match(/^\/books\/ise-element-practice\/element-\d+$/);
  
  return (
    <>
      {!hideLayout && !isElementPage && !isMockExamPage && <Header />}
      {children}
      {!hideLayout && !isElementPage && !isMockExamPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<Books />} />
            <Route path="/interactive-books" element={<InteractiveBooks />} />
            <Route path="/interactive-guides" element={<InteractiveBooks />} />
            <Route path="/books/cire-interactive" element={<CIREInteractiveBook />} />
            <Route path="/books/cire-interactive/:elementId" element={<CIREElement />} />
            <Route path="/books/rse-interactive" element={<RSEInteractiveBook />} />
            <Route path="/books/rse-interactive/:elementId" element={<RSEElement />} />
            <Route path="/books/derivatives-interactive" element={<DerivativesInteractiveBook />} />
            <Route path="/books/derivatives-interactive/:elementId" element={<DerivativesElement />} />
            <Route path="/books/ise-interactive" element={<ISEInteractiveBook />} />
            <Route path="/books/ise-interactive/:elementId" element={<ISEElement />} />
            <Route path="/ise-mock-exam" element={<ISEMockExam />} />
            <Route path="/derivatives-mock-exam" element={<DerivativesMockExam />} />
            <Route path="/rse-mock-exam" element={<RSEMockExam />} />
            <Route path="/cire-mock-exam" element={<CIREMockExam />} />
            <Route path="/books/cire-mock-exam-pack" element={<CIREMockExamPackSalesPage />} />
            <Route path="/books/cire-mock-exams/mock-exam-1" element={<MockExam1 />} />
            <Route path="/books/cire-mock-exams/mock-exam-2" element={<MockExam2 />} />
            <Route path="/books/cire-mock-exams/mock-exam-3" element={<MockExam3 />} />
            <Route path="/books/cire-mock-exams/mock-exam-4" element={<MockExam4 />} />
            <Route path="/books/cire-mock-exams/mock-exam-5" element={<MockExam5 />} />
            <Route path="/books/cire-element-bank" element={<CIREElementQuestionBankSalesPage />} />
            <Route path="/books/cire-element-practice/element-1" element={<CIREElement1Practice />} />
            <Route path="/books/cire-element-practice/element-2" element={<CIREElement2Practice />} />
            <Route path="/books/cire-element-practice/element-3" element={<CIREElement3Practice />} />
            <Route path="/books/cire-element-practice/element-4" element={<CIREElement4Practice />} />
            <Route path="/books/cire-element-practice/element-5" element={<CIREElement5Practice />} />
            <Route path="/books/cire-element-practice/element-6" element={<CIREElement6Practice />} />
            <Route path="/books/cire-element-practice/element-7" element={<CIREElement7Practice />} />
            <Route path="/books/cire-element-practice/element-8" element={<CIREElement8Practice />} />
            <Route path="/books/cire-element-practice/element-9" element={<CIREElement9Practice />} />
            <Route path="/books/rse-mock-exam-pack" element={<RSEMockExamPackSalesPage />} />
            <Route path="/books/rse-mock-exams/mock-exam-1" element={<RSEMockExam1 />} />
            <Route path="/books/rse-mock-exams/mock-exam-2" element={<RSEMockExam2 />} />
            <Route path="/books/rse-mock-exams/mock-exam-3" element={<RSEMockExam3 />} />
            <Route path="/books/rse-mock-exams/mock-exam-4" element={<RSEMockExam4 />} />
            <Route path="/books/rse-mock-exams/mock-exam-5" element={<RSEMockExam5 />} />
            <Route path="/books/rse-element-bank" element={<RSEElementQuestionBankSalesPage />} />
            <Route path="/books/rse-element-practice/element-1" element={<RSEElement1Practice />} />
            <Route path="/books/rse-element-practice/element-2" element={<RSEElement2Practice />} />
            <Route path="/books/rse-element-practice/element-3" element={<RSEElement3Practice />} />
            <Route path="/books/rse-element-practice/element-4" element={<RSEElement4Practice />} />
            <Route path="/books/rse-element-practice/element-5" element={<RSEElement5Practice />} />
            <Route path="/books/rse-element-practice/element-6" element={<RSEElement6Practice />} />
            <Route path="/books/rse-element-practice/element-7" element={<RSEElement7Practice />} />
            <Route path="/books/rse-element-practice/element-8" element={<RSEElement8Practice />} />
            <Route path="/books/rse-element-practice/element-9" element={<RSEElement9Practice />} />
            <Route path="/books/derivatives-mock-exam-pack" element={<DerivativesMockExamPackSalesPage />} />
            <Route path="/books/derivatives-mock-exams/mock-exam-1" element={<DerivativesMockExam1 />} />
            <Route path="/books/derivatives-mock-exams/mock-exam-2" element={<DerivativesMockExam2 />} />
            <Route path="/books/derivatives-mock-exams/mock-exam-3" element={<DerivativesMockExam3 />} />
            <Route path="/books/derivatives-mock-exams/mock-exam-4" element={<DerivativesMockExam4 />} />
            <Route path="/books/derivatives-mock-exams/mock-exam-5" element={<DerivativesMockExam5 />} />
            <Route path="/books/derivatives-element-bank" element={<DerivativesElementQuestionBankSalesPage />} />
            <Route path="/books/derivatives-element-practice/element-1" element={<DerivativesElement1 />} />
            <Route path="/books/derivatives-element-practice/element-2" element={<DerivativesElement2 />} />
            <Route path="/books/derivatives-element-practice/element-3" element={<DerivativesElement3 />} />
            <Route path="/books/derivatives-element-practice/element-4" element={<DerivativesElement4 />} />
            <Route path="/books/derivatives-element-practice/element-5" element={<DerivativesElement5 />} />
            <Route path="/books/derivatives-element-practice/element-6" element={<DerivativesElement6 />} />
            <Route path="/books/derivatives-element-practice/element-7" element={<DerivativesElement7 />} />
            <Route path="/books/derivatives-element-practice/element-8" element={<DerivativesElement8 />} />
            <Route path="/books/ise-mock-exam-pack" element={<ISEMockExamPackSalesPage />} />
            <Route path="/ise-mock-exam/1" element={<ISEMockExam1 />} />
            <Route path="/ise-mock-exam/2" element={<ISEMockExam2 />} />
            <Route path="/ise-mock-exam/3" element={<ISEMockExam3 />} />
            <Route path="/ise-mock-exam/4" element={<ISEMockExam4 />} />
            <Route path="/ise-mock-exam/5" element={<ISEMockExam5 />} />
            <Route path="/books/ise-element-question-bank" element={<ISEElementQuestionBankSalesPage />} />
            <Route path="/books/ise-element-practice/element-1" element={<ISEElement1Practice />} />
            <Route path="/books/ise-element-practice/element-2" element={<ISEElement2Practice />} />
            <Route path="/books/ise-element-practice/element-3" element={<ISEElement3Practice />} />
            <Route path="/books/ise-element-practice/element-4" element={<ISEElement4Practice />} />
            <Route path="/books/ise-element-practice/element-5" element={<ISEElement5Practice />} />
            <Route path="/books/ise-element-practice/element-6" element={<ISEElement6Practice />} />
            <Route path="/books/ise-element-practice/element-7" element={<ISEElement7Practice />} />
            <Route path="/blog/cire-interactive-study-guide" element={<CIREInteractiveBlog />} />
            <Route path="/blog/rse-interactive-study-guide" element={<RSEInteractiveGuideBlog />} />
            <Route path="/blog/derivatives-interactive-study-guide" element={<DerivativesInteractiveGuideBlog />} />
            <Route path="/blog/ise-interactive-study-guide" element={<ISEInteractiveGuideBlog />} />
            <Route path="/blog/ciro-exams-complete-guide" element={<AllCIROExamsGuideBlog />} />
            <Route path="/blog/investment-accounts-asset-classes" element={<InvestmentAcademy />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/institutional" element={<Institutional />} />
            <Route path="/corporate-discounts" element={<CorporateDiscounts />} />
            <Route path="/corporate/cire-access" element={<CIRECorporateAccess />} />
            <Route path="/corporate/rse-access" element={<RSECorporateAccess />} />
            <Route path="/corporate/ise-access" element={<ISECorporateAccess />} />
            <Route path="/corporate/derivatives-access" element={<DerivativesCorporateAccess />} />
            <Route path="/diagnostic-tool" element={<DiagnosticTool />} />
            <Route path="/cire-exam" element={<CIREExam />} />
            <Route path="/rse-exam" element={<RSEExam />} />
            <Route path="/ise-exam" element={<ISEExam />} />
            <Route path="/derivatives-exam" element={<DerivativesExam />} />
            <Route path="/exam-comparison" element={<ExamComparison />} />
            <Route path="/cire-study-guide" element={<CIREStudyGuide />} />
            <Route path="/rse-study-guide" element={<RSEStudyGuide />} />
            <Route path="/ise-study-guide" element={<ISEStudyGuide />} />
            <Route path="/derivatives-study-guide" element={<DerivativesStudyGuide />} />
            <Route path="/traders-exam" element={<TradersExam />} />
            <Route path="/traders-exam-study-guide" element={<TradersExamStudyGuide />} />
            <Route path="/educational-institutes" element={<EducationalInstitutes />} />
            <Route path="/norquest-college" element={<NorquestCollege />} />
            <Route path="/derivatives-strategy-lab" element={<DerivativesStrategyLab />} />
            <Route path="/blog/options-strategies-complete-guide" element={<DerivativesStrategiesBlog />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
